(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/assets/javascripts/router.js');

'use strict';

const playViews = {
  Single: svs.vikinglotto.views.PlaySinglePage,
  System: svs.vikinglotto.views.PlaySystemPage,
  Package: svs.vikinglotto.views.PlayPackagePage
};
const rules = svs.numbergames.rules.getRules({
  productId: svs.numbergames.productMapping.CONSTANTS.VIKINGLOTTO
});
svs.vikinglotto.Router = Backbone.Router.extend({
  routes: svs.core.data.routes,
  initialize(_ref) {
    let app = _ref.app;
    svs.vikinglotto.logger.debug('svs.router.vikinglotto initialize');
    this.app = app;
  },
  playSingle() {
    svs.vikinglotto.logger.debug('svs.vikinglotto.Router playSingle');
    this.app.showView(new svs.vikinglotto.views.PlaySinglePage());
  },
  playPackageGame(size) {
    svs.vikinglotto.logger.debug('svs.vikinglotto.Router playPackage');
    if (!size) {
      size = rules.defaultPackage;
      this.navigate("fardiga-spel/".concat(size), {
        replace: true
      });
    }
    this.app.showView(new svs.vikinglotto.views.PlayPackagePage({
      size
    }));
  },
  playSystem() {
    svs.vikinglotto.logger.debug('svs.vikinglotto.Router playSystem');
    this.app.showView(new svs.vikinglotto.views.PlaySystemPage());
  },
  playProlongation() {
    svs.vikinglotto.logger.debug('svs.vikinglotto.Router prolongWager');
    if (!svs.vikinglotto.data.prolongWager) {
      svs.vikinglotto.logger.warn('svs.vikinglotto.Router prolongWager. No wager to prolong.');
      this.navigate('', {
        trigger: true,
        replace: true
      });
      return;
    }
    const editWagerFunction = svs.numbergames.game.utils.prolongation.getEditWagerFunction({
      playViews,
      modelOptions: {
        hasTickets: svs.vikinglotto.data.hasTickets
      }
    });
    const playedWagerModel = new svs.numbergames.mybets_common_wager.models.Wager(svs.vikinglotto.data.prolongWager, {
      parse: true
    });
    editWagerFunction(playedWagerModel);
  },
  changeSubscription() {
    svs.vikinglotto.logger.debug('svs.vikinglotto.Router changeSubscription');
    const subscription = new svs.numbergames.mybets_common_wager.models.Subscription(svs.vikinglotto.data.subscription, {
      parse: true
    });
    svs.numbergames.game.utils.editWager.showPlayView({
      playedWager: subscription,
      playViews,
      viewOptions: {
        showDrawCount: false,
        showPlayTogether: false
      }
    });
  },
  fractionGames() {
    svs.vikinglotto.logger.debug('svs.vikinglotto.Router fractionGames');
    this.app.showView(new svs.vikinglotto.views.FractiongamesPage());
  },
  prolongation() {
    svs.vikinglotto.logger.debug('svs.vikinglotto.Router prolongation');
    const hasSession = svs.numbergames.game_app.utils.handleProlongLogin();
    if (hasSession) {
      this.app.showView(new svs.vikinglotto.views.ProlongationPage());
    }
  },
  result(dateString) {
    if (dateString) {
      try {
        const date = dateFns.parseISO(dateString);
        const readableDate = dateFns.format(date, 'd MMMM yyyy', {
          locale: dateFns.locales.sv
        });
        svs.core.data.title = {
          readableDate
        };
        svs.core.data.metaDescription = {
          readableDate
        };
      } catch (e) {
        svs.vikinglotto.logger.error('svs.vikinglotto.Router result failed to parse date', e);
      }
    }
    svs.vikinglotto.logger.debug('svs.vikinglotto.Router result');
    this.app.showView(new svs.vikinglotto.views.ResultPage({
      dateString
    }));
  }
});

 })(window);